import { Translation } from "../model/Language.js";
import { Modal, ModalOptions } from "./Modal.js";
import { ModalItem } from "./ModalItem.js";

export interface ShareOptions extends ModalOptions {

}

export interface ShareItem {
    info: Translation;
    title: Translation;
    description: Translation;
    url: Translation;
    initiator: HTMLElement;
}

export class Share extends Modal {

    private _current: ShareItem = null;
    private _facebook: ModalItem;
    private _twitter: ModalItem;
    private _device: ModalItem;
    private _info: HTMLDivElement;

    public create(options: ShareOptions): this {

        super.create(options);

        this._info = this.addInfo("");

        this._facebook = this.addItem({
            icon: "fab fa-facebook",
            label: {
                de: "Auf Facebook teilen",
                en: "Share on Facebook"
            },
            url: "#",
            iconSize: "large"
        });

        this._twitter = this.addItem({
            icon: "fab fa-twitter",
            label: {
                de: "Auf Twitter teilen",
                en: "Share on Twitter"
            },
            url: "#",
            iconSize: "large"
        });

        if ((navigator as any).share !== undefined) {
            var systemIcon = "fal fa-share";
            if (e5.Caps.os === "android") {
                systemIcon = "fab fa-android";
            }
            else if (e5.Caps.os === "windows") {
                systemIcon = "fab fa-windows";
            }
            else if (e5.Caps.os === "ios") {
                systemIcon = "fab fa-apple";
            }

            this._device = this.addItem({
                icon: systemIcon,
                action: "share-os",
                label: {
                    de: "Über Ihr Gerät teilen",
                    en: "Share through your device"
                },
                iconSize: "large"
            });
        }

        e5.event.on(document.body, "click", `[data-action="share-current"]`, (e) => {
            var element = e.target as HTMLElement;
            this.share({
                initiator: element,
                info: {
                    de: "Teilen Sie diese Webseite",
                    en: "Share this website"
                },
                description: {
                    de: "Teilen Sie diese Webseite",
                    en: "Share this website"
                },
                title: {
                    de: 'Teilen',
                    en: 'Share'
                },
                url: {
                    de: window.location.href,
                    en: window.location.href
                }
            });
        });

        e5.event.on(this.element, "click", `[data-action="share-os"]`, (e) => {
            if (!this._current) {
                return;
            }

            (navigator as any).share({
                title: lang.translate(this._current.title),
                url: lang.translate(this._current.url),
                // text: e5.Text.stripTags(lang.translate(this._current.description))
            }).catch((exc: any) => { });
        });

        return this;
    }

    public share(options: ShareItem) {
        this._current = options;

        lang.setType(this._info, "html", options.info);

        var url = lang.translate(options.url);
        this._facebook.url = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
        this._twitter.url = "https://twitter.com/intent/tweet?url=" + encodeURIComponent(url);

        this.show({
            initiator: options.initiator
        });
    }
}